import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { FormattedMessage, useIntl } from "react-intl";
import { HandleAddNewTeacher } from "../../../actions/teacherMutations";
import { formatServiceError } from "../../../Utilities/serviceErrorHelper";

const createTeacherInClass = ({ teacher, classId }) =>
  HandleAddNewTeacher(teacher, classId);

export default function useAddNewTeacherToClass() {
  const intl = useIntl();
  const queryClient = useQueryClient();
  const mutateCreateTeacherInClass = useMutation({
    mutationFn: createTeacherInClass,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["FetchTeacherInformation"] });
      queryClient.invalidateQueries({ queryKey: ["FetchClassByClassId"] });
      queryClient.invalidateQueries({
        queryKey: ["FetchSchoolDataBySchoolId"],
      });
      toast.success(<FormattedMessage id="ClassUpdated" />);
    },
    onError: (err) => {
      toast.warn(formatServiceError(intl, err?.response?.data));
    },
  });

  return (values, classId) =>
    mutateCreateTeacherInClass.mutate({ teacher: values, classId });
}
